import Cookies from 'js.cookie';

export const CookieBanner = (() => {
	'use strict';

	function init() {
		cookie_bnaner();
		checkCookie();
	}

	function checkCookie() {
		let myCookie = Cookies.get('acceptedCookiePrompt');

		if ( myCookie == undefined ) {
			$('.cookie-banner').css('display', 'flex');
		}

	}

	function cookie_bnaner() {
		let banner = document.querySelector('.cookie-banner');

		if (!banner) return;

		$('.cookie--btn').on('click', function(e) {
			e.preventDefault();
			var acceptance = this.classList.contains('accept');
			Cookies.set('acceptedCookiePrompt', acceptance);
			if ( acceptance ) {
				gaCall();
			}
			$('.cookie-banner').hide();
		});

	}
	return {
		init: init
	};
})();
